module.exports = __webpack_public_path__ + "ff01ff25d1553e10d7a9df43018c3857.jpg";